/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { Form, InputNumber, Button, Select, Input } from "antd";
import { updateRedemCode, getRedemCode } from "../../features/redem-code/redemCodeSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { message as msg } from "antd";
import { useParams } from "react-router-dom";

const { Option } = Select;

const EditRedemCode = () => {
  const { id } = useParams();
  const [messageApi, contextHolder] = msg.useMessage();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError, updating, message, isUpdateSuccess, redemCode } = useSelector(
    (state) => state.redemCode
  );
  const [form] = Form.useForm();

  const onFinish = (values) => {
    const data = { ...values };
    dispatch(updateRedemCode({ id, data }));
  };

  useEffect(() => {
    loadRedemCode();
  }, []);

  useEffect(() => {
    if (redemCode) {
      form.setFieldsValue({
        code: redemCode.code,
        hole_in_one_credits: redemCode.hole_in_one_credits,
        hole_out_credits: redemCode.hole_out_credits,
        total_redemption_limit: redemCode.total_redemption_limit,
        status: redemCode.status?.toString(),
      });
    }
  }, [redemCode]);

  useEffect(() => {
    if (isError && message) {
      messageApi.open({
        type: "error",
        content: message,
      });
    }

    if (isUpdateSuccess) {
      messageApi.open({
        type: "success",
        content: "Redem Code is updated successfully",
      });
      navigate("/admin/redem-code");
    }
  }, [isError, message, isUpdateSuccess, messageApi, navigate]);

  const loadRedemCode = () => {
    dispatch(getRedemCode(id));
  };

  return (
    <div>
      {contextHolder}
      <h3 className="mb-4 title">Redem Code</h3>
      <Form layout="vertical" onFinish={onFinish} form={form}>
      <Form.Item
          label="Code"
          name="code"
          rules={[{ required: true, message: "Please input the redem code!" }]}
        >
          <Input />
        </Form.Item>
        
        <Form.Item
          label="Hole In One Credit"
          name="hole_in_one_credits"
          rules={[{ required: true, message: "Please input the Hole In One credits!" }]}
        >
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          label="Hole Out Credit"
          name="hole_out_credits"
          rules={[{ required: true, message: "Please input the Hole Out credits!" }]}
        >
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          label="Total Redemption Limit"
          name="total_redemption_limit"
          rules={[{ required: true, message: "Please input the total redemption limit!" }]}
        >
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          label="Status"
          name="status"
          rules={[{ required: true, message: "Please select the status!" }]}
        >
          <Select>
            <Option value="1">Active</Option>
            <Option value="0">Inactive</Option>
          </Select>
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" disabled={updating}>
            {updating ? "Submitting..." : "Submit"}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default EditRedemCode;
